export default {

  areImagesLoaded() {
    const printDoc = document.getElementById('printDocument')
    const images = printDoc.querySelectorAll('img')

    for (const image of images) {
      if (!this.imageIsCompleteLoaded(image)) return false
    }

    return true
  },

  imageIsCompleteLoaded(image) {
    return image.complete && image.naturalHeight !== 0
  },

  async waitUntilImagesArePresent(callback, attempt) {

    if (!attempt) {
      attempt = 0
    }

    const maxAttempts = 5;
    if (!this.areImagesLoaded()) {
      attempt++;
      setTimeout(() => this.waitUntilImagesArePresent(callback, attempt), 10);
      return;
    } else if (attempt >= maxAttempts) {
      return;
    }
    callback();
  }

}
